import { PencilEdit02Icon, UserIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
	Item,
	ItemActions,
	ItemContent,
	ItemDescription,
	ItemMedia,
	ItemTitle,
} from "@/components/ui/item";
import { getClientLinkDisplayText, sortClientLinks } from "@/lib/labels";
import type { PhysicalPersonsClientLink } from "@/types";

export type EditingPerson = {
	id: number;
	full_name: string;
	birth_number: string;
	client_links: PhysicalPersonsClientLink[];
};

type EditingPersonItemVariant = "add_as_client" | "merge" | "link_to_business";

interface EditingPersonItemProps {
	person: EditingPerson;
	onCancel: () => void;
	variant?: EditingPersonItemVariant;
}

const VARIANT_MESSAGES: Record<EditingPersonItemVariant, string> = {
	add_as_client:
		"Po odeslání budou údaje aktualizovány a osoba přidána jako klient.",
	merge: "Po odeslání budou údaje aktualizovány a osoby sloučeny.",
	link_to_business:
		"Po odeslání budou údaje aktualizovány a osoba propojena s právnickou osobou.",
};

export function EditingPersonItem({
	person,
	onCancel,
	variant = "add_as_client",
}: EditingPersonItemProps) {
	const sortedClientLinks = sortClientLinks(person.client_links);

	return (
		<div className="flex flex-col gap-1.5">
			<Badge variant="default">
				<HugeiconsIcon
					icon={PencilEdit02Icon}
					data-icon="inline-start"
					strokeWidth={2}
				/>
				Právě upravujete
			</Badge>
			<Item variant="muted">
				<ItemMedia variant="icon">
					<HugeiconsIcon icon={UserIcon} strokeWidth={2} />
				</ItemMedia>
				<ItemContent>
					<ItemTitle>{person.full_name}</ItemTitle>
					<ItemDescription>
						{person.birth_number}
						{sortedClientLinks.length > 0 && (
							<>
								{" · "}
								{getClientLinkDisplayText(sortedClientLinks[0])}
								{sortedClientLinks.length > 1 &&
									` +${sortedClientLinks.length - 1}`}
							</>
						)}
					</ItemDescription>
				</ItemContent>
				<ItemActions>
					<Button type="button" variant="ghost" size="sm" onClick={onCancel}>
						Zrušit
					</Button>
				</ItemActions>
			</Item>
			<p className="text-muted-foreground text-sm">
				{VARIANT_MESSAGES[variant]}
			</p>
		</div>
	);
}
